import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faStamp } from '@fortawesome/pro-regular-svg-icons/faStamp'
import type { DrugApprovedUse } from '@modules/drugs/helpers/getTreatmentPageData'

function DrugPropertyBlock({
  conditionName,
  fdaApprovalDate,
  notes,
}: {
  conditionName?: string
  fdaApprovalDate?: string
  notes?: string
}) {
  return (
    <div className='my-2 flex'>
      <Icon className='mr-3 mt-2' icon={faStamp} />
      <div>
        <Text
          className='mb-1'
          styleName={'p-small-strong'}
          value={conditionName}
        />
        <div className='flex'>
          <Text
            className='mr-2'
            styleName={'p-tiny-strong'}
            value={fdaApprovalDate}
          />
          <Text styleName={'p-tiny'} value={notes} />
        </div>
      </div>
    </div>
  )
}

export default function TreatmentApprovedProperties({
  drugApprovedUses,
}: {
  drugApprovedUses: DrugApprovedUse[]
}) {
  return (
    <>
      {drugApprovedUses.map((property, key) => (
        <DrugPropertyBlock
          conditionName={property.conditionName}
          fdaApprovalDate={property.fdaApprovalDate}
          key={key}
          notes={property.notes}
        />
      ))}
    </>
  )
}
